import { useTranslation } from "react-i18next";
import {
  SmartPricingRule,
} from "../../services/exports/Interfaces";
import CustomCarousel from "./CustomCarousel";
import useScreenType from "../../hooks/useScreenType";
import classnames from "classnames";
import SmartPricingDeal from "../smart-pricing/SmartPricingDeal";

interface Props {
  rules: SmartPricingRule[];
  className?: string;
}

const SmartPricingCarousel = (props: Props): JSX.Element => {
  const { rules, className } = props;

  const { t } = useTranslation(null, { keyPrefix: "Components:Carousel:SmartPricingCarousel" });

  const { isDesktop } = useScreenType();

  return (
    <div className={classnames("relative w-full", className)}>
      <CustomCarousel
        data={rules}
        renderItem={({ item }) => (
          <SmartPricingDeal data={item} key={`smart-pricing-rule-${item.id}`} />
        )}
        itemsPerSlide={isDesktop ? 3.5 : 1.25}
        slideJump={isDesktop ? 3 : 2}
        itemHeight={120}
        arrowsPosition="top"
        arrowsClassName="lg:mr-medium mr-small"
        itemsClassName="lg:pl-none pl-small"
        title={
          <h5 className="lg:ml-none ml-small uppercase">
            {t("deals")}
          </h5>
        }
        headerClassName="mb-mini"
      />
    </div>
  );
};

export default SmartPricingCarousel;
